export default "__VITE_ASSET__CVkR1zZA__"